export const $$store = Symbol('store');